import NewIntegrationAccountSelect from './NewIntegrationAccountSelect';

export default NewIntegrationAccountSelect;
